export async function retry<T>(
  fn: () => Promise<T>,
  retries = 0,
  delay = 500
): Promise<T> {
  try {
    return await fn();
  } catch (e) {
    if (retries <= 0) throw e;
    await new Promise(r => setTimeout(r, delay));
    return retry(fn, retries - 1, delay * 2);
  }
}